<template>
  <div class="coupon-stamp-component" v-show="isShowStamp">
    <div class="inner">
      <i>{{ stampText }}</i>
    </div>
  </div>
</template>
<script lang="ts">
import { getCouponStateText } from './business';
import { CouponState } from '../../type';
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component
export default class CouponItemStamp extends Vue {
  @Prop() public state!: CouponState;

  /**
   * 获取邮戳展示状态
   * 只有过期和已使用才展示
   */
  get isShowStamp() {
    return (
      this.state === CouponState.Expired || this.state === CouponState.Used
    );
  }

  /**
   * 获取邮戳文案
   */
  get stampText() {
    return getCouponStateText(this.state);
  }
}
</script>
<style lang="less" scoped>
@import "../../less/main.less";

.coupon-stamp-component {
  opacity: 0.12;
  border-color: #000;
  border-style: solid;
  border-radius: 50%;
  width: 120 / @rem;
  height: 120 / @rem;
  border-width: 4 / @rem;

  .inner {
    border-width: 2 / @rem;
    transform: scale(0.96, 0.96);
    border-color: #000;
    border-style: solid;
    border-radius: 50%;
    width: 116 / @rem;
    height: 116 / @rem;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      transform: rotate(-15deg);
      text-align: center;
      font-weight: 500;
      font-style: normal;
    }
  }
}
</style>

